/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Organizerfollowers1Inputs */

const en_organizerfollowers1 = /** @type {(inputs: Organizerfollowers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} followers`)
};

const de_organizerfollowers1 = /** @type {(inputs: Organizerfollowers1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Follower`)
};

/**
* | output |
* | --- |
* | "{count} followers" |
*
* @param {Organizerfollowers1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerfollowers1 = /** @type {((inputs: Organizerfollowers1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerfollowers1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerfollowers1(inputs)
	return de_organizerfollowers1(inputs)
});
export { organizerfollowers1 as "organizerFollowers" }